import React from 'react';

/**
 * LicenseTierSelector — displays license option cards (Free, Pro, Pro Developer, Lifetime)
 * and lets the user choose one. Drives the displayed price and the cart item's license_option.
 */
const LicenseTierSelector = ({ options = [], selected, onChange }) => {
  const visible = options.filter(o => o.visible !== false);
  if (!visible.length) return null;

  return (
    <div className="mb-8" data-testid="license-tier-selector">
      <h3 className="text-sm font-semibold uppercase tracking-widest text-slate-400 mb-4">
        Choose Your License
      </h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {visible.map(opt => {
          const isSelected = selected?.id === opt.id;
          return (
            <button
              key={opt.id}
              data-testid={`license-option-${opt.id}`}
              onClick={() => onChange(opt)}
              className={`relative text-left rounded-xl border-2 p-4 transition-all duration-200 focus:outline-none
                ${isSelected
                  ? 'border-blue-500 bg-blue-950/40 shadow-lg shadow-blue-500/20'
                  : 'border-slate-700 bg-slate-800/50 hover:border-slate-500'
                }`}
            >
              {/* Badge */}
              {opt.badge && (
                <span className="absolute -top-2.5 right-3 text-[10px] font-bold uppercase tracking-widest
                  bg-gradient-to-r from-blue-500 to-violet-500 text-white px-2 py-0.5 rounded-full">
                  {opt.badge}
                </span>
              )}

              {/* Header */}
              <div className="flex items-start justify-between mb-1">
                <p className="font-bold text-white text-base leading-tight">{opt.label}</p>
                <div className={`mt-0.5 w-4 h-4 rounded-full border-2 flex-shrink-0 flex items-center justify-center
                  ${isSelected ? 'border-blue-500 bg-blue-500' : 'border-slate-600'}`}>
                  {isSelected && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                </div>
              </div>

              {/* Price */}
              <p className="text-2xl font-black text-white mt-2">
                {opt.price === 0
                  ? <span className="text-emerald-400">Free</span>
                  : opt.billing === 'once'
                    ? <>${opt.price}<span className="text-sm font-normal text-slate-400"> one-time</span></>
                    : <>${opt.price}<span className="text-sm font-normal text-slate-400">/yr</span></>
                }
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LicenseTierSelector;
